import { useLocation } from "react-router-dom";

import querystring from "query-string";

import { useConfig } from "@jti/app-context/useConfig";
import { isUrlWhitelisted } from "@jti/fe-common";

type UseWhitelistedReturnUrl = () => { returnUrl?: string };

type ResolveWhitelistedReturnUrlArgs = {
  search: string;
  hash: string;
  whitelistedDomains: string[];
};

export const resolveWhitelistedReturnUrl = ({
  search,
  hash,
  whitelistedDomains,
}: ResolveWhitelistedReturnUrlArgs): { returnUrl?: string } => {
  const { returnUrl } = querystring.parse(search);

  if (typeof returnUrl !== "string") {
    return { returnUrl: undefined };
  }

  const rawHash = typeof window === "undefined" ? undefined : window.location.hash;
  const hasHashFragment = !!hash && hash.startsWith("#/");
  const hasSplitHashRouterReturnUrl = !!rawHash?.includes("?returnUrl=");
  const shouldRestoreHashFragment = hasHashFragment && !returnUrl.includes("#") && hasSplitHashRouterReturnUrl;

  const resolvedReturnUrl = shouldRestoreHashFragment ? `${returnUrl}${hash}` : returnUrl;
  const whitelistedReturnUrl = isUrlWhitelisted(resolvedReturnUrl, whitelistedDomains) ? resolvedReturnUrl : undefined;

  return {
    returnUrl: whitelistedReturnUrl,
  };
};

export const useWhitelistedReturnUrl: UseWhitelistedReturnUrl = () => {
  const { search, hash } = useLocation();
  const { whitelistedDomains } = useConfig();

  return resolveWhitelistedReturnUrl({ search, hash, whitelistedDomains });
};
